export const openAccordion = () => {
    jQuery(document).ready(function( $ ) {
        $('#trainers-centers').on('click', '.trainers-ac__header',  function(e){
            $(this).hasClass('open') ? $(this).removeClass('open') : $(this).addClass('open');
        })
    });    
}